import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "ReÅ¡i Freda",
  "description": "",
  "published": "2007-04-10T00:00:00.000Z",
  "redirect_from": ["/blog/rei-freda/swizec/236"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ste kdaj operirali puhastega zajÄka? Kaj pa nadevanega igraÄastega zajÄka?`}</p>
    <p>{`Nadejam se negativnega odgovora ... No sedaj `}<a parentName="p" {...{
        "href": "http://www.10mg.nl/"
      }}>{`ga lahko`}</a>{`! Pa še zelo zabavno in smešno je! Moram reÄi, da sem zelo uÅ¾ival v tej kratki flash igri, ki je sicer igriva samo enkrat ali dvakrat in ni nekaj, kar bi se dalo venomer preigravati. SplaÄa se poiskusiti.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      